import React from "react";
import axios from "../api";

export const getTokens = async (code, session_state) => {
  return await axios.get(
    `/token/microsoft/i_got_code/?code=${code}&session_state=${session_state}`
  );
};
